
import React, { Component } from "react";
import DatePanel3 from './DatePanel3'
import Search from "../../Search/Search";
import FilterRender from "../../Search/FilterRender";

import "../../Overview/overview.css";
import "./filterpanel.css";

export default class FilterPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.onChange = this.onChange.bind(this)
  }
  onChange (filter) {
    if (this.props.propagateState)
      this.props.propagateState ("filter", filter)
  }

  render() {
    return (
      <div className="filter-row">
        <Search onChange={this.onChange} clear={this.props.update}>
          <FilterRender />
        </Search>

        <DatePanel3 {...this.props} />

        {this.props.children}
      </div>
    );
  }
}
